import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { CloudVendor } from '../models/cloud-vendor.model';
import { GetVendor } from '../interfaces/services/vendor.interface';
import Helper from '../Util/helper';

@Injectable({
  providedIn: 'root'
})
export class CloudVendorService implements GetVendor {

  constructor() { }

  getVendorByName(vendor: string): Observable<CloudVendor> {
    let obs = new Observable<CloudVendor>((value) => {
      value.next(Helper.getVendor(vendor));
      value.complete();

      return {
        unsubscribe() { }
      }
    });

    return obs;
  }

  handleError(error: HttpErrorResponse): Observable<any> {
    return throwError(error.error);
  }
}
